export default __webpack_public_path__ + "static/media/cameragot-screenshot-05.79867863.png";